module.exports = require("core-js/modules/es.map.js");